<script>
  import { Icon, ChatBubbleLeftRight, CommandLine, Camera } from "svelte-hero-icons";
  import ImagePreview from "$lib/Elements/ImagePreview.svelte";
  import { imageManager } from "$lib/shared_stores";
  import { jobs } from "../store";

  export let events = [];

  // Sort events by timestamp/iteration
  $: sortedEvents = [...events].sort((a, b) => {
    const iterA = a.data?.iteration || 0;
    const iterB = b.data?.iteration || 0;
    if (iterA !== iterB) return iterA - iterB;
    // Within same iteration, order: capture -> reasoning -> tool_calls
    const typeOrder = { agent_capture: 0, agent_reasoning: 1, agent_tool_calls: 2 };
    return (typeOrder[a.type] || 99) - (typeOrder[b.type] || 99);
  });

  function formatToolCall(tc) {
    if (tc.tool === "remote_control" && tc.args?.action) {
      return `Press "${tc.args.action}"`;
    }
    if (tc.tool === "mark_complete") {
      return `Mark complete${tc.args?.explanation ? `: ${tc.args.explanation}` : ""}`;
    }
    return `${tc.tool}(${JSON.stringify(tc.args)})`;
  }
</script>

{#if events.length > 0}
  <div class="mb-2 mx-2 px-3 py-2 bg-gray-800/50 rounded-lg border border-gray-700/50">
    <h4 class="font-bold mb-2 text-purple-400">Agent:</h4>
    <div class="space-y-2">
      {#each sortedEvents as event}
        {#if event.type === "agent_capture"}
          <!-- Screenshot -->
          <div class="flex items-start gap-2">
            <div
              class="flex-shrink-0 w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center"
            >
              <Icon src={Camera} class="w-3 h-3 text-white" />
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-xs text-content-subtle mb-1">
                Iteration {event.data.iteration} - Screenshot
              </div>
              {#if event.data.image}
                <div class="rounded-lg overflow-hidden max-w-xs">
                  <ImagePreview
                    src={imageManager.src(event.data.image)}
                    alt="Agent screenshot"
                    class="max-w-full h-auto"
                    sessionId={$jobs.m3u8}
                  />
                </div>
              {/if}
            </div>
          </div>
        {:else if event.type === "agent_reasoning"}
          <!-- Reasoning/thought -->
          <div class="flex items-start gap-2">
            <div
              class="flex-shrink-0 w-5 h-5 rounded-full bg-purple-600 flex items-center justify-center"
            >
              <Icon src={ChatBubbleLeftRight} class="w-3 h-3 text-white" />
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-xs text-content-subtle mb-1">
                Iteration {event.data.iteration} - {event.data.reasoning_type === "follow_up"
                  ? "Follow-up"
                  : "Reasoning"}
              </div>
              <div class="bg-gray-800 rounded-lg p-2 text-xs text-gray-200 whitespace-pre-wrap">
                {event.data.reasoning}
              </div>
            </div>
          </div>
        {:else if event.type === "agent_tool_calls"}
          <!-- Tool calls -->
          <div class="flex items-start gap-2">
            <div
              class="flex-shrink-0 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center"
            >
              <Icon src={CommandLine} class="w-3 h-3 text-white" />
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-xs text-content-subtle mb-1">
                Iteration {event.data.iteration} - Tool Call{event.data.tool_calls?.length > 1
                  ? "s"
                  : ""}
              </div>
              <div class="space-y-1">
                {#each event.data.tool_calls || [] as tc}
                  <div
                    class="bg-gray-800 rounded px-2 py-0.5 text-[10px] flex items-center gap-1.5"
                  >
                    <span class="text-cyan-400">{formatToolCall(tc)}</span>
                  </div>
                {/each}
              </div>
            </div>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}
